import Swal from "sweetalert2";

const Toast = Swal.mixin({
    showCancelButton: false,
    showConfirmButton: false,
    timerProgressBar: true,
    timer: 2000,
});

export default Toast